export const pillars = ['Rapports d’intervention', 'Enquêtes', 'Auditions', 'Synthèses', 'Briefings', 'Transmissions'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'Rapports d’intervention & comptes rendus™',
  pack: 'Le pack opérationnel',
  desc: 'Structurez vos rapports d’intervention, comptes rendus, chronologies, observations et descriptions factuelles à partir de vos informations.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Enquêtes, constatations & éléments de preuve™',
  pack: 'Le pack investigation',
  desc: 'Organisez les constatations, éléments matériels, chronologies, informations recueillies et synthèses nécessaires au suivi d’un dossier.'
}, {
  n: 3,
  emoji: '📕',
  title: 'Auditions, déclarations & procédures™',
  pack: 'Le pack procédural',
  desc: 'Préparez et structurez vos auditions, déclarations, questions, chronologies et comptes rendus à partir des informations disponibles.'
}, {
  n: 4,
  emoji: '📓',
  title: 'Renseignement, analyse & synthèses opérationnelles™',
  pack: 'Le pack intelligence',
  desc: 'Transformez des informations dispersées en synthèses structurées, notes de situation, briefings et analyses opérationnelles.'
}, {
  n: 5,
  emoji: '📗',
  title: 'Interventions sensibles & situations complexes™',
  pack: 'Le pack intervention',
  desc: 'Structurez les situations impliquant plusieurs personnes, des événements évolutifs ou des interventions nécessitant une restitution particulièrement claire.'
}, {
  n: 6,
  emoji: '📙',
  title: 'Administration, transmissions & efficacité professionnelle™',
  pack: 'Le pack productivité',
  desc: 'Créez plus rapidement vos notes, transmissions, comptes rendus, communications professionnelles, synthèses et plans d’action.'
}];
export const volumeIncludes = ['🧠 Prompts prêts à copier-coller', '📝 Champs [À PERSONNALISER]', '📋 Structures adaptées aux différents types de documents', '🔍 Méthodes pour vérifier les informations fournies', '⚙️ Workflows pratiques', '📱 Utilisation sur ordinateur, tablette ou smartphone', '🤖 Compatible avec les principaux assistants IA'];
export const bonuses = [{
  n: '01',
  title: 'BWC → Rapport IA™',
  tagline: 'Transformez vos notes, observations et transcriptions en rapports structurés.',
  desc: 'Une méthode pour organiser les informations issues de vos notes ou transcriptions et les transformer en une structure de rapport exploitable.',
  price: '32 €',
  cover: 'https://cdn.magicpatterns.com/uploads/nWhA3aDYcJhkcgWizAsT7i/BONO_1.webp'
}, {
  n: '02',
  title: 'Préparation aux auditions & audiences IA™',
  tagline: 'Préparez vos faits, questions, chronologies et dossiers avec une méthode structurée.',
  desc: 'Organisez les informations disponibles, identifiez les points à clarifier et préparez vos éléments de travail avec l’aide de l’IA.',
  price: '29 €',
  cover: 'https://cdn.magicpatterns.com/uploads/7zH5uYzUodqUqZ2zCnAVTy/BONO_1_(1).webp'
}, {
  n: '03',
  title: 'Générateur de briefings opérationnels™',
  tagline: 'Transformez des informations dispersées en briefings clairs et structurés.',
  desc: 'Un système pour organiser rapidement les informations importantes, les points d’attention, les éléments à transmettre et les actions à suivre.',
  price: '32 €',
  cover: 'https://cdn.magicpatterns.com/uploads/4BcLDceZTGZCfYcTe5oiwM/BONO_1_(2).webp'
}, {
  n: '04',
  title: 'Checklist IA — Confidentialité & données sensibles™',
  tagline: 'Une méthode pratique pour vérifier vos informations avant de les utiliser avec une IA.',
  desc: 'Apprenez à identifier les informations sensibles, à anonymiser les données lorsque cela est nécessaire et à intégrer une étape de contrôle avant utilisation.',
  price: '27 €',
  cover: 'https://cdn.magicpatterns.com/uploads/hkHyp4gsmGd2aiKPEbn7EB/BONO_1_(3).webp'
}];
